// Central translation dictionary aggregator.
// Each feature area lives in its own file under ./locales/{namespace}.js
// exporting { uk, en }. Add new namespaces here.

import common from './locales/common';
import nav from './locales/nav';
import profileSwitcher from './locales/profileSwitcher';
import settings from './locales/settings';
import login from './locales/login';
import profile from './locales/profile';
import leave from './locales/leave';
import presentations from './locales/presentations';
import schedule from './locales/schedule';
import finance from './locales/finance';
import chat from './locales/chat';
import notifications from './locales/notifications';
import teacher from './locales/teacher';
import studentDash from './locales/studentDash';
import admin from './locales/admin';
import editor from './locales/editor';
import games from './locales/games';
import landing from './locales/landing';
import onboarding from './locales/onboarding';
import modals from './locales/modals';
import reader from './locales/reader';
import backend from './locales/backend';
import video from './locales/video';
import classroom from './locales/classroom';
import support from './locales/support';
import offers from './locales/offers';
import homework from './locales/homework';
import dictionary from './locales/dictionary';
import ken from './locales/ken';
import policy from './locales/policy';
import shop from './locales/shop';
import checkout from './locales/checkout';
import virtualClassroom from './locales/virtualClassroom';
import enrollment from './locales/enrollment';
import levelTest from './locales/levelTest';
import trialForm from './locales/trialForm';

const namespaces = {
  common,
  nav,
  profileSwitcher,
  settings,
  login,
  profile,
  leave,
  presentations,
  schedule,
  finance,
  chat,
  notifications,
  teacher,
  studentDash,
  admin,
  editor,
  games,
  landing,
  onboarding,
  modals,
  reader,
  backend,
  video,
  classroom,
  support,
  offers,
  homework,
  dictionary,
  ken,
  policy,
  shop,
  checkout,
  virtualClassroom,
  enrollment,
  levelTest,
  trialForm,
};

const translations = { uk: {}, en: {} };
for (const [ns, dict] of Object.entries(namespaces)) {
  translations.uk[ns] = dict.uk;
  translations.en[ns] = dict.en;
}

export default translations;
